// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRecommendedServicePackageServiceV2 {
  /** Услуга **/
  serviceType: EServiceType;
  /** Кол-во объявлений **/
  count?: number;
  /** Цена после применения скидки **/
  price?: number;
  /** Баллы СА **/
  auctionPoints?: number;
  /** Длительность предложения в днях **/
  durationInDays: number;
}
export enum EServiceType {
  /** Платное **/
  'DebitObject' = 'debitObject',
  /** Премиум публикация - 103 **/
  'PremiumObject' = 'premiumObject',
  /** Тор 3 - 104 **/
  'Top3' = 'top3',
  /** Аукцион **/
  'Auction' = 'auction',
  /** Аукцион **/
  'Standard' = 'standard',
  /** Бесплатное **/
  'Free' = 'free',
}
